<div class="playback-in-out-points-content">

  @if (title) {
    <div class="playback-in-out-title">{{ title }}</div>
  }

  <div class="playback-in-out">

    <!-- Points -->
    <div class="playback-in-out-points">

      <div class="points">
        <div class="title">Start:</div>
        <div class="point-timecode">{{ inPoint }}</div>
        <div class="button secondary" (click)="setInPoint()">Set</div>
      </div>

      <div class="points">
        <div class="title">End:</div>
        <div class="point-timecode">{{ outPoint }}</div>
        <div class="button secondary" (click)="setOutPoint()">Set</div>
      </div>

    </div>

    <!-- Action -->
    <div class="button-actions">
      <div class="button" [class.disabled]="!points?.start || !points?.end || inProgress" (click)="process()">{{ inProgress? 'Processing' : 'Process'}}</div>
    </div>

  </div>

</div>